import { gql } from "@apollo/client";

import { CONFIG_ELEMENT_FRAGMENT } from "components/Environment/gql";

export const GET_MODULE_ENVIRONMENT = gql`
  query GetModuleEnvironment($moduleId: ID!) {
    module(id: $moduleId) {
      id
      attachedContexts {
        id
        contextName
        config {
          ...configElement
        }
      }
      canWrite
      name
      runtimeConfig {
        context {
          contextId
          contextName
        }
        element {
          ...configElement
        }
      }
    }
  }
  ${CONFIG_ELEMENT_FRAGMENT}
`;
